/**
 * @desc 邀请参加
 */
import { AuctionInviteForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type InviteAuctionApplyParameter = AuctionInviteForm

const method = 'POST'
const url = '/trade/operation/apply/auction/invite'

export const inviteAuctionApplyApi = (
  data?: InviteAuctionApplyParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

inviteAuctionApplyApi.method = method
inviteAuctionApplyApi.url = url
